import { useEffect, useState } from 'react';
import { themes, type ThemeName, type Tokens } from './tokens';

function detectInitial(): ThemeName {
  if (typeof document === 'undefined') return 'light';
  return document.documentElement.classList.contains('dark') ? 'dark' : 'light';
}

export function useAuroraTheme(): { theme: ThemeName; t: Tokens } {
  const [theme, setTheme] = useState<ThemeName>(detectInitial);

  useEffect(() => {
    if (typeof document === 'undefined') return;
    const html = document.documentElement;
    const sync = () => setTheme(html.classList.contains('dark') ? 'dark' : 'light');
    sync();
    const obs = new MutationObserver(sync);
    obs.observe(html, { attributes: true, attributeFilter: ['class'] });
    return () => obs.disconnect();
  }, []);

  return { theme, t: themes[theme] };
}
